<template>
  <div class="my_order">
    <div class="order_main">
      <div class="order_left">
        <user-tab></user-tab>
      </div>

      <div class="order_right">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import userTab from "./../../components/user/user_tab";
export default {
  components: {
    userTab
  },
  data() {
    return {};
  },
  mounted() {
    var _this = this;
    for (let i of _this.$store.state.headerTabList) {
      i.isSelected = false;
      if (i.name == "首页") {
        i.isSelected = true;
      }
    }
    for (let i of _this.$store.state.userList) {
      i.isSelected = false;
      if (i.name == "我的商品") {
        i.isSelected = true;
      }
    }
  },

  methods: {}
};
</script>
<style lang="scss" scoped>
.order_right {
  background: #fff;
}
</style>
